import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-star-notes]',
};

const classes = {
  swiperPagination: '.swiper-pagination',
};

class StarNotesCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(max-width:639px)');
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousel();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousel() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy(true, true);
    }

    if (this.breakpoint.matches) {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        loop: true,
        init: true,
        pagination: {
          el: classes.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy(true, true);
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousel();
    });
  }
}

customElements.define('star-notes', StarNotesCarousel);
